import React from 'react';
import i18n from "i18next";
import { Button, Tooltip, Row, Col } from 'antd';
import { ArrowLeftOutlined, ApartmentOutlined, BookOutlined, DatabaseOutlined, 
  UnorderedListOutlined, FileZipOutlined, FontSizeOutlined } from '@ant-design/icons'
import ExportCatalog from '../../components/export/ExportCatalog';
import TranslateLangCheck from '../../components/service/TranslateLangCheck';

class SKSACatalogCard extends React.Component {

  state = {
    modal: "none",		//Состояние модельного окна. none - не показывается, export - отобразить диалог экспорта каталога/графа
  };

  getCatalogPath(path = "") {
    const { adminCatalog, adminGraph } = this.props;

    return (
      "/catalog/" +
      encodeURIComponent(adminCatalog) +
      "/" +
      encodeURIComponent(adminGraph) +
      (path ? "/" + path : "")
    );
  }

  onExportDialog(e){
    e.preventDefault();
    this.setState({modal:"export"});
  }

  onCheckTranslate(e){
    e.preventDefault();
    this.setState({modal:"translate"});
  }

  cancelOperation(){
    this.setState({modal:"none"});
  };

  render() {
    const { modal } = this.state;
    const {adminGraph, adminCatalog} = this.props;
    return (
      <Row>
        <Col span={12}>
            <Tooltip placement="top" title={i18n.t('views.admin.return_catalogs')}>
              <Button type="dashed" icon={<ArrowLeftOutlined />} onClick={(e)=> this.props.router.navigate("/catalogs")}></Button>
            </Tooltip>
            &nbsp;<b>Graph:</b>&nbsp;{adminGraph};&nbsp;&nbsp;<b>Catalog:</b>&nbsp;{adminCatalog}
          </Col>
        <Col span={12} style={{"display": "flex", "flexDirection": "row-reverse"}}>
          <Tooltip placement="top" title={i18n.t('views.admin.landing.sksaowl')}>
            <Button type="dashed" icon={<ApartmentOutlined />} onClick={(e)=> this.props.router.navigate(this.getCatalogPath("sksaowl"))}></Button>
          </Tooltip>
          &nbsp;&nbsp;
          <Tooltip placement="top" title={i18n.t('views.admin.landing.catalog')}>
            <Button type="dashed" icon={<DatabaseOutlined />} onClick={(e)=> this.props.router.navigate(this.getCatalogPath(""))}></Button>
          </Tooltip>
          &nbsp;&nbsp;
          <Tooltip placement="top" title={i18n.t('views.admin.landing.vocabs')}>
            <Button type="dashed" icon={<UnorderedListOutlined />} onClick={(e)=> this.props.router.navigate(this.getCatalogPath("vocabs"))}></Button>
          </Tooltip>
          &nbsp;&nbsp;
          <Tooltip placement="top" title={i18n.t('views.admin.landing.schemes')}>
            <Button type="dashed" icon={<BookOutlined />} onClick={(e)=> this.props.router.navigate(this.getCatalogPath("schemes"))}></Button>
          </Tooltip>
          &nbsp;&nbsp;
          <Tooltip placement="top" title={i18n.t('views.catalog.export')}>
            <Button icon={<FileZipOutlined />} onClick={(e)=> this.onExportDialog(e)}/>
          </Tooltip>                              
          &nbsp;&nbsp;
          <Tooltip placement="top" title={"Проверка литеральных констант"}>
            <Button icon={<FontSizeOutlined />} onClick={(e)=> this.onCheckTranslate(e)}/>
          </Tooltip>                              
          
        </Col>
        { modal=="export" && <ExportCatalog open={true} onClose={()=> this.cancelOperation()} graphURI={adminGraph} catalogURI={adminCatalog}/>}
        { modal=="translate" && <TranslateLangCheck open={true} onClose={()=> this.cancelOperation()} router={this.props.router}/>}
      </Row>
    )
  }
}

export default SKSACatalogCard;